import { combineReducers } from '@reduxjs/toolkit';
import snackbarReducer from './snackbarSlice';
import authUserReducer from './authUserSlice';
import drawerReducer from './drawerSlice';
import dialogReducer from './dialogSlice';
import modalReducer from './modalSlice'
import permissionReducers from './permissionSlice';
import financialYearReducer from "./financialYearSlice";
import sortingReducer from "./sortingSlice";
import tableSearchReducer from "./tableSearchSlice";
import showFiltersReducer from "./showFiltersSlice";
import refreshReducer from "./masters/refreshSlice";
import addProductReducer from "./quotation/productSlice";
import mastersReducer from "./masters/mastersSlice";
import folderReducer from './archive/folderSlice'
import activeInvoiceReducer from './invoice/activeInvoiceSlice'
import navigationStateReducer from './invoice/navigationState'
import customerConfigReducer from './customerConfigSlice';
import companyReducer from './companySlice';
import { getCurrentCompanyUUID } from '../../utils/utils';

export const appReducer = combineReducers({
    snackbar: snackbarReducer,
    authUser: authUserReducer,
    drawer: drawerReducer,
    dialog: dialogReducer,
    modal: modalReducer,
    permission: permissionReducers,
    financialYear: financialYearReducer,
    sorting: sortingReducer,
    tableSearch: tableSearchReducer,
    showFilters: showFiltersReducer,
    refresh: refreshReducer,
    masters: mastersReducer,
    product: addProductReducer,
    activeInvoice: activeInvoiceReducer,
    folder: folderReducer,
    navigation: navigationStateReducer,
    customerConfig: customerConfigReducer,
})

const rootReducer = (state: any = { company: { currentCompanyUUID: '' } }, action: any) => {
    // const companyUUID = state.company?.currentCompanyUUID || getCurrentCompanyUUID();
    const companyUUID = getCurrentCompanyUUID();

    if (action.type === 'LOGOUT_COMPANY') {
        return {
            ...state,
            [companyUUID]: appReducer(undefined, { type: '@@INIT' }),
            company: { currentCompanyUUID: '' },
        };
    }

    const currentCompanyState = state?.[companyUUID] ?? appReducer(undefined, { type: '@@INIT' });

    return {
        ...state,
        company: companyReducer(state.company, action),
        [companyUUID]: appReducer(currentCompanyState, action),
    };
};

export default rootReducer;